import React from 'react'
import PropTypes from 'prop-types'
import { withRouter, Switch as RouterSwitch } from 'react-router-dom'
import PrivateRoute from '../../../hocs/PrivateRoute'
import PromotionList from './List'
import PromotionForm from './Form'

// Routes for the Promotions module (spec: promotions).
const PromotionsRoutes = props => (
  <RouterSwitch>
    <PrivateRoute exact path={props.match.path} component={PromotionList} />
    <PrivateRoute exact path={`${props.match.path}/new`} component={PromotionForm} />
    <PrivateRoute exact path={`${props.match.path}/:id`} component={PromotionForm} />
  </RouterSwitch>
)

PromotionsRoutes.propTypes = {
  match: PropTypes.object
}

export default withRouter(PromotionsRoutes)
